import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getProgressiveCertifications: ['carrer', 'prog', 'acadPlan'],
  getProgressiveCertificationsRequest: null,
  getProgressiveCertificationsSuccess: ['data'],
  getProgressiveCertificationsFailure: ['error'],
  clearProgressiveCertifications: null
});

export { Creators, Types };
